export default __webpack_public_path__ + "static/media/avatar4.9bcc22b7.png";